import { apiClient } from '../client';
import { downloadBlob } from '../downloadBlob';
import type { OwnerType } from '@never2busy/shared';

export interface FileAsset {
  id: number;
  ownerType: OwnerType;
  ownerId: number;
  originalName: string;
  storagePath: string;
  size: number;
  mimeType: string;
  createdAt: string;
  createdById: number;
}

export const filesApi = {
  async list(ownerType: OwnerType, ownerId: number): Promise<FileAsset[]> {
    const { data } = await apiClient.get<FileAsset[]>('/files', {
      params: { ownerType, ownerId },
    });
    return data;
  },
  async upload(
    file: File,
    ownerType: OwnerType,
    ownerId: number,
    onProgress?: (percent: number) => void,
  ): Promise<FileAsset> {
    const form = new FormData();
    form.append('file', file);
    form.append('ownerType', ownerType);
    form.append('ownerId', String(ownerId));
    const { data } = await apiClient.post<FileAsset>('/files', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded / evt.total) * 100));
        }
      },
    });
    return data;
  },
  async remove(id: number): Promise<void> {
    await apiClient.delete(`/files/${id}`);
  },
  /** Descarga preservando el JWT. Ver downloadBlob.ts para el porque. */
  async download(id: number, filename: string): Promise<void> {
    await downloadBlob(`/files/${id}/download`, filename);
  },
};
